import { Spinner } from "react-bootstrap"
import { STATUS } from "../../Utils/Constant"

export const LoadingContainer = ({ status, children }) => {
    return (
        status === STATUS.FETCHING ?
            <div style={{ height: "100vh", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
            :
            children
    )
}